import { render, staticRenderFns } from "./KnittingQcView.vue?vue&type=template&id=4bd5bb18&scoped=true"
import script from "./KnittingQcView.vue?vue&type=script&lang=js"
export * from "./KnittingQcView.vue?vue&type=script&lang=js"
import style0 from "./KnittingQcView.vue?vue&type=style&index=0&id=4bd5bb18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd5bb18",
  null
  
)

export default component.exports